module.exports = __webpack_public_path__ + "static/media/15@720w.c513b396.jpg";